import React, { useState } from 'react';
import clsx from 'clsx';
import { FieldWrapper } from './FieldWrapper';

const DEFAULT_COUNTRY = {
  code: 'UG',
  dialCode: '+256',
  flag: '🇺🇬',
  name: 'Uganda',
};

const COUNTRIES = [
  { code: 'UG', dialCode: '+256', flag: '🇺🇬', name: 'Uganda' },
  // { code: 'KE', dialCode: '+254', flag: '🇰🇪', name: 'Kenya' },
  // { code: 'TZ', dialCode: '+255', flag: '🇹🇿', name: 'Tanzania' },
  // { code: 'RW', dialCode: '+250', flag: '🇷🇼', name: 'Rwanda' },
];

export const PhoneInputField = (props) => {
  const {
    className,
    onChange,
    value,
    registration,
    error,
    required,
    placeholder = 'Phone number',
    disabled,
  } = props;

  const [country, setCountry] = useState(DEFAULT_COUNTRY);
  const [open, setOpen] = useState(false);

  const handleSelectCountry = (c) => {
    setCountry(c);
    setOpen(false);
  };

  return (
    <FieldWrapper error={error}>
      <div className="relative">
        <div
          className={clsx(
            'flex items-center w-full px-3 py-3 border bg-white border-gray-100 rounded-full shadow-sm focus-within:ring-[#383D4E] focus-within:border-[#383D4E]',
            className
          )}
        >
          {/* Country Selector */}
          <div className="relative flex items-center pr-2 border-r border-gray-200 mr-2">
            <button
              type="button"
              onClick={() => setOpen((s) => !s)}
              className="flex items-center gap-1 text-sm text-gray-700 focus:outline-none"
            >
              <span>{country.flag}</span>
              <span className="text-gray-600">{country.dialCode}</span>
              <svg
                className="w-3 h-3 text-gray-500"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M19 9l-7 7-7-7"
                />
              </svg>
            </button>

            {/* Dropdown */}
            {open && (
              <div className="absolute top-12 left-0 bg-white border border-gray-100 rounded-lg shadow-md z-50 w-44">
                {COUNTRIES.map((c) => (
                  <button
                    key={c.code}
                    type="button"
                    onClick={() => handleSelectCountry(c)}
                    className="w-full text-left px-3 py-2 text-sm hover:bg-gray-50 flex items-center gap-2"
                  >
                    <span>{c.flag}</span>
                    <span>{c.name}</span>
                    <span className="ml-auto text-gray-500">{c.dialCode}</span>
                  </button>
                ))}
              </div>
            )}
          </div>

          {/* Input */}
          <input
            type="tel"
            value={value}
            disabled={disabled}
            required={required}
            placeholder={placeholder}
            className="flex-1 appearance-none bg-transparent outline-none text-gray-800 placeholder-gray-500 text-sm"
            onChange={onChange}
            {...registration}
          />
        </div>
      </div>
    </FieldWrapper>
  );
};
